const action = {
    general: 'Ocorreu um erro ao executar a ação. Tente novamente mais tarde.',
    sign_in_identifier_changed: 'A ação não pode alterar o identificador de início de sessão usado nesta verificação.',
};
export default Object.freeze(action);
